<div
  class="hstack gap-1"
  *ngrxLet="entity | get : props.path | cobMeta as cobMeta"
>
  <lui-avatar [color]="cobMeta.color" [size]="props.size">
    <mat-icon [svgIcon]="cobMeta.icon"></mat-icon>
  </lui-avatar>
  <div class="d-flex flex-column">
    <span class="mat-body-strong">{{ cobMeta.title }}</span>
    <span>{{ entity | get : props.subtitlePath }}</span>
  </div>
</div>
